export default "__VITE_ASSET__BQYwuYou__"